@if (getFirstImageUrl() && getFirstImageUrl() !== '') {
<a class="cursor-pointer" tabindex="0" [routerLink]="[`/${pathNameSignal()}/detail`, dataSignal().id]">
  <figure>
    <img
      [src]="replaceBucket.replaceBucket(getFirstImageUrl())"
      [alt]="dataSignal().name"
      [title]="dataSignal().name"
      loading="lazy"
      class="item-image"
    />
    <figcaption class="caption">
      @if(dataSignal().hot_badge_enable === 1) {
      <img
        src="assets/icons/icon-Fire.png"
        alt="ไอคอนสำหรับสินค้ายอดนิยม"
        title="ไอคอนสำหรับสินค้ายอดนิยม"
        loading="lazy"
        class="hot-badge"
      />
      } @switch (headingLevel) { @case ('h3') {
      <h3 class="font-size-22 font-weight-semibold line-clamp-2">{{ dataSignal().name }}</h3>
      } @default {
      <h2 class="font-size-22 font-weight-semibold line-clamp-2">{{ dataSignal().name }}</h2>
      } }
    </figcaption>
  </figure>
</a>
} @else {
<div class="item-image"></div>
}
